import { render, staticRenderFns } from "./wuju-install.vue?vue&type=template&id=5bbd3bf8&scoped=true&"
import script from "./wuju-install.vue?vue&type=script&lang=js&"
export * from "./wuju-install.vue?vue&type=script&lang=js&"
import style0 from "./wuju-install.vue?vue&type=style&index=0&id=5bbd3bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd3bf8",
  null
  
)

export default component.exports